import Nav from "../components/Nav";
import Footer from "../components/Footer";
import SEO from "../components/SEO";
import PageShell from "../components/marketing/PageShell";
import PageHero from "../components/marketing/PageHero";
import CTAStrip from "../components/marketing/CTAStrip";
import AppBadge from "../components/marketing/AppBadge";

// TODO: replace with real store URLs when live
const IOS_URL = "#";
const ANDROID_URL = "#";

export default function DownloadPage() {
  return (
    <PageShell testid="page-download">
      <SEO
        title="Download App"
        description="The BRep app — book services, upload videos, message your coach. Download for iOS and Android."
        path="/download"
      />
      <Nav />
      <PageHero
        eyebrow="Download App"
        title="BRep in"
        titleAccent="your pocket."
        subtitle="Book services, upload videos, and message your coach — all in one place. Available on iOS and Android."
      />
      <section className="px-6 md:px-12 py-16 md:py-24">
        <div className="max-w-[1600px] mx-auto grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
          <div className="lg:col-span-6">
            <div className="text-[11px] tracking-[0.32em] uppercase text-[#2A5BFF] mb-6">Available on</div>
            <div className="flex flex-col sm:flex-row gap-4">
              <AppBadge store="ios" href={IOS_URL} />
              <AppBadge store="android" href={ANDROID_URL} />
            </div>
            <p className="mt-8 text-white/60 max-w-md">
              Everything you need to train smarter — from booking a lift review to messaging your coach — in one native app.
            </p>
          </div>
          <div className="lg:col-span-6">
            <div className="relative aspect-[4/3] overflow-hidden border border-white/10">
              <img
                src="https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400"
                alt="Athlete recording a lift for BRep review"
                className="w-full h-full object-cover grayscale"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#050510] via-transparent to-transparent" />
              <div className="absolute bottom-6 left-6 right-6 flex items-end justify-between text-[10px] tracking-[0.3em] uppercase text-white/60">
                <span>Every Rep.</span>
                <span className="text-[#2A5BFF]">Better.</span>
              </div>
            </div>
          </div>
        </div>
      </section>
      <CTAStrip
        title="Train smarter, today."
        subtitle="Browse services, or download the app to start."
        primary={{ to: "/services", label: "View Services" }}
        secondary={{ to: "/coaches", label: "Find a Coach" }}
      />
      <Footer />
    </PageShell>
  );
}
